export enum AdvisorSpecializationKey {
	Investments = "investments",
	LifeInsurance = "life_insurance",
	NonLifeInsurance = "non_life_insurance",
	Mortgages = "mortgages",
	ConsumerLoans = "consumer_loans",
	Retirement = "retirement",
	Comprehensive = "comprehensive",
}
